import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import type { CreateMembershipType, UpdateMembershipType } from "../../../schemas/membership-type";
import { queryKeys } from "../../query-keys";

export function useMembershipTypes(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.clubPortal.membershipTypes(clubId ?? ""),
		queryFn: () => clubApi.membershipTypes.list(clubId as string),
		enabled: !!clubId,
	});
}

export function useCreateMembershipType(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (data: CreateMembershipType) => clubApi.membershipTypes.create(clubId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipTypes(clubId),
			});
		},
	});
}

export function useUpdateMembershipType(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ typeId, data }: { typeId: string; data: UpdateMembershipType }) =>
			clubApi.membershipTypes.update(clubId, typeId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipTypes(clubId),
			});
		},
	});
}

export function useDeleteMembershipType(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (typeId: string) => clubApi.membershipTypes.delete(clubId, typeId),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipTypes(clubId),
			});
		},
	});
}
